/* eslint-disable  react/prop-types */

import React from 'react';

const ExCancelIcon = ({ width = 24, height = 24, style = {} }) => (
  <svg
    style={style}
    width={width}
    height={height}
    viewBox={`0 0 ${24} ${24}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="ex-cancel-icon"
  >
    <path d="M20 4L4 20" stroke="#666666" strokeWidth="2" strokeLinecap="round" />
    <path d="M20 20L4 4" stroke="#666666" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default ExCancelIcon;
